import React from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';

const ChooseExcelTemplate = (props) => {
    const {currState,toggleChooseExcelModel,downloadCSVHandler,chooseExcelTemplateChangeHandler,attachInternalCSV,composePage} = props;
    const {excelTemplateList,isChooseExcelModelOpen,excelTemplateId} = currState;

	return (
		<Modal size="lg" show={isChooseExcelModelOpen} onHide={toggleChooseExcelModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Choose Template </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label> Template </label>
                            <select className="form-control" name="excelTemplateId" value={excelTemplateId} onChange={chooseExcelTemplateChangeHandler}>
                                <option value="">&nbsp;</option>
                                { excelTemplateList ?
                                    excelTemplateList.map((item,ind) => {
                                        return <option value={item.id}>{item.name}</option>
                                    })
                                : null }
                            </select>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                
                    <a onClick={toggleChooseExcelModel} className="btn btn-cancel mr-2"> Cancel </a> 
                    <a onClick={(composePage)? e=>attachInternalCSV() : e=>downloadCSVHandler(e,false)} className="btn primary_bg"> Apply </a> 
               
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(ChooseExcelTemplate);